import { useGetWiringAccountList } from './queries/wiring/query';
import { useCompanyId } from './useCompanyId';

const useWiringAvailable = () => {
  const { companyId } = useCompanyId();
  const { data: accountListData } = useGetWiringAccountList({ companyId, includeBalance: false });
  const accountList = accountListData?.Data?.data?.items || [];

  const wiringAvailable = accountList.some(
    (account) =>
      account.bankCode === '081' || account.bankCode === '004' || account.bankCode === '001',
  );

  return wiringAvailable;
};

export default useWiringAvailable;
